<template>
  <div>
    <player-rush-previews-table
      v-if="isRushPreviewsTableVisible"
      :playerId="playerId"
      :rushes="rushes"
    />

    <p v-if="message !== null">
      {{message}}
    </p>

    <loading-indicator v-if="isLoading" />
  </div>
</template>

<script>
import notifier from '../notifier.js';
import { HTTP } from '../http-common.js';

import LoadingIndicator from './LoadingIndicator.vue';
import PlayerRushPreviewsTable from './PlayerRushPreviewsTable.vue';

const LOADING_STATUS__INIT    = 1;
const LOADING_STATUS__LOADING = 2;
const LOADING_STATUS__NORMAL  = 3;
const LOADING_STATUS__ERROR   = 4;

export default {
  name: 'PlayerRushes',

  components: {
    LoadingIndicator,
    PlayerRushPreviewsTable,
  },

  props: {
    playerId: {
      type: Number,
      required: true,
    }
  },

  data() {
    return {
      loadingStatus: LOADING_STATUS__INIT,
      rushes: null,
    };
  },

  computed: {
    /** @returns {boolean} */
    isLoading() {
      return this.loadingStatus === LOADING_STATUS__LOADING;
    },

    /** @returns {boolean} */
    isLoadedNormal() {
      return this.loadingStatus === LOADING_STATUS__NORMAL;
    },

    /** @returns {?string} */
    message() {
      if(!this.isLoadedNormal) {
        return null;
      }

      if(this.rushes !== null && this.rushes.length === 0) {
        return 'No rushes.';
      }

      return null;
    },

    /** @returns {boolean} */
    isRushPreviewsTableVisible() {
      if(!this.isLoadedNormal) {
        return false;
      }

      const rushes = this.rushes;
      if(rushes === null) {
        return false;
      }

      return rushes.length > 0;
    },
  },

  created() {
    this.loadRushes();
  },

  methods: {
    loadRushes() {
      notifier.deleteSenderNotifications(this);

      this.loadingStatus = LOADING_STATUS__LOADING;

      const url = `/player/${this.playerId}/rushes`;
      HTTP.get(url)
      .then(response => {
        this.rushes = response.data.data;
        this.loadingStatus = LOADING_STATUS__NORMAL;
      })
      .catch(err => {
        this.loadingStatus = LOADING_STATUS__ERROR;
        notifier.showError(err, {sender: this});
      });
    },
  },
};
</script>
